export function getCityName(cityKey, cityNameByKey = {}) {
  const normalizedKey = String(cityKey || "").toLowerCase().trim();
  return cityNameByKey[normalizedKey] || cityKey || "—";
}

export function normalizeSearchValue(value) {
  return String(value ?? "").trim().toLowerCase();
}

export function formatDateTime(value) {
  if (!value) {
    return "—";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleString("ru-RU");
}

export function formatDurationMs(milliseconds) {
  if (!Number.isFinite(milliseconds) || milliseconds < 0) {
    return "—";
  }

  const totalMinutes = Math.floor(milliseconds / 60000);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;

  if (days > 0) {
    return `${days} д ${hours} ч ${minutes} мин`;
  }

  if (hours > 0) {
    return `${hours} ч ${minutes} мин`;
  }

  return `${minutes} мин`;
}

export function getActivityActionLabel(action) {
  if (action === "client_started") return "Включение";
  if (action === "client_stopped") return "Остановка";
  if (action === "client_switched") return "Смена клиента";
  return action || "—";
}
